import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header d-flex flex-row justify-content-between" }
const _hoisted_3 = { class: "h5" }
const _hoisted_4 = { class: "btn-toolbar align-items-center justify-content-end" }
const _hoisted_5 = {
  key: 0,
  class: "d-flex align-items-center mb-xs-2 pe-sm-3"
}
const _hoisted_6 = { class: "form-check form-switch ms-2 my-1" }
const _hoisted_7 = ["checked"]
const _hoisted_8 = ["href"]
const _hoisted_9 = { class: "table-responsive calendar-table" }
const _hoisted_10 = { class: "table schedule-table text-center mb-0" }
const _hoisted_11 = { class: "text-center text-nowrap p-0" }
const _hoisted_12 = { class: "class-time p-2" }
const _hoisted_13 = { class: "" }
const _hoisted_14 = { class: "class-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_class_card = _resolveComponent("class-card")!
  const _component_class_form_modal = _resolveComponent("class-form-modal")!
  const _component_confirm_delete_class_modal = _resolveComponent("confirm-delete-class-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _createElementVNode("span", _hoisted_3, [
          (_ctx.titleIcon != undefined)
            ? (_openBlock(), _createElementBlock("i", {
                key: 0,
                class: _normalizeClass(_ctx.titleIcon + ' me-2')
              }, null, 2))
            : _createCommentVNode("", true),
          _createTextVNode(" " + _toDisplayString(_ctx.title), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        (_ctx.hasEditRole)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              (_ctx.editPermission)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    class: "btn btn-secondary btn-sm me-1",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openClassModal()))
                  }, [...(_cache[2] || (_cache[2] = [
                    _createElementVNode("i", { class: "fas fa-plus fa-fw me-1" }, null, -1),
                    _createTextVNode("Nueva Clase ", -1)
                  ]))]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("input", {
                  class: "form-check-input",
                  type: "checkbox",
                  role: "switch",
                  checked: _ctx.editPermission,
                  id: "on-off-edit",
                  onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.changeEditPermission && _ctx.changeEditPermission(...args)))
                }, null, 40, _hoisted_7),
                _cache[3] || (_cache[3] = _createElementVNode("label", {
                  class: "form-check-label",
                  for: "on-off-edit"
                }, [
                  _createElementVNode("i", { class: "fas fa-pencil-alt fa-sm" })
                ], -1))
              ])
            ]))
          : _createCommentVNode("", true),
        _cache[5] || (_cache[5] = _createElementVNode("div", { class: "mb-1 w-100 d-block d-sm-none" }, null, -1)),
        (_ctx.scheduleId == 'trading-academy')
          ? (_openBlock(), _createElementBlock("a", {
              key: 1,
              class: "btn btn-telegram btn-sm ms-4",
              href: 'https://t.me/' + _ctx.getTelegramBotUsername,
              target: "_blank"
            }, [...(_cache[4] || (_cache[4] = [
              _createElementVNode("i", { class: "fab fa-telegram-plane fa-fw me-1" }, null, -1),
              _createTextVNode(" Telegram Bot ", -1),
              _createElementVNode("i", { class: "fas fa-robot fa-fw ms-2" }, null, -1)
            ]))], 8, _hoisted_8))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("table", _hoisted_10, [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            _cache[6] || (_cache[6] = _createElementVNode("th", { class: "text-nowrap" }, "Hora \\ Día", -1)),
            _createElementVNode("th", {
              class: _normalizeClass([{ 'current-day': _ctx.currentDay == 'monday' }, "time-marker"])
            }, null, 2),
            _createElementVNode("th", {
              class: _normalizeClass({ 'current-day': _ctx.currentDay == 'monday' })
            }, "Lunes", 2),
            _createElementVNode("th", {
              class: _normalizeClass({ 'current-day': _ctx.currentDay == 'tuesday' })
            }, "Martes", 2),
            _createElementVNode("th", {
              class: _normalizeClass({ 'current-day': _ctx.currentDay == 'wednesday' })
            }, "Miércoles", 2),
            _createElementVNode("th", {
              class: _normalizeClass({ 'current-day': _ctx.currentDay == 'thursday' })
            }, "Jueves", 2),
            _createElementVNode("th", {
              class: _normalizeClass({ 'current-day': _ctx.currentDay == 'friday' })
            }, "Viernes", 2),
            _createElementVNode("th", {
              class: _normalizeClass({ 'current-day': _ctx.currentDay == 'saturday' })
            }, "Sábado", 2),
            _createElementVNode("th", {
              class: _normalizeClass({ 'current-day': _ctx.currentDay == 'sunday' })
            }, "Domingo", 2)
          ])
        ]),
        _createElementVNode("tbody", null, [
          ([..._ctx.schedule].length)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.schedule, (time, index) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: `${time}-${index}`
                }, [
                  _createElementVNode("th", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.getLocalizedHour(time[0])), 1)
                    ])
                  ]),
                  _createElementVNode("td", {
                    class: _normalizeClass({ 'current-day': _ctx.currentDay == 'monday' })
                  }, [
                    (_ctx.isNow(time[0], _ctx.schedule[index + 1]))
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: "hour-location fw-bold",
                          style: _normalizeStyle(`top: ${_ctx.isNow(time[0], _ctx.schedule[index + 1])}%;`)
                        }, [
                          _createElementVNode("span", null, _toDisplayString(_ctx.minutes.format("hh:mm a")), 1)
                        ], 4))
                      : _createCommentVNode("", true)
                  ], 2),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.entries(time[1]), (day, ind) => {
                    return (_openBlock(), _createElementBlock("td", {
                      class: _normalizeClass({ 'current-day': _ctx.currentDay === day[0] }),
                      key: day[0]
                    }, [
                      _createElementVNode("div", _hoisted_14, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(day[1], (c, idx) => {
                          return (_openBlock(), _createBlock(_component_class_card, {
                            key: c,
                            classData: c,
                            classTime: time[0],
                            classDate: _ctx.getClassDate(ind + 1, time[0]),
                            multiple: day[1].length > 1,
                            first: Number(idx) === 0,
                            last: Number(idx) >= day[1].length - 1,
                            editPermission: _ctx.editPermission,
                            classesPerDay: day[1],
                            classIndex: Number(idx),
                            onEditClass: _ctx.editClass,
                            onDeleteClass: _ctx.confirmDeleteClass
                          }, null, 8, ["classData", "classTime", "classDate", "multiple", "first", "last", "editPermission", "classesPerDay", "classIndex", "onEditClass", "onDeleteClass"]))
                        }), 128))
                      ])
                    ], 2))
                  }), 128))
                ]))
              }), 128))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createVNode(_component_class_form_modal, {
      id: "classFormModal",
      classInfo: _ctx.currentClassInfo,
      scheduleType: _ctx.scheduleType,
      onClose: _ctx.closeClassModal
    }, null, 8, ["classInfo", "scheduleType", "onClose"]),
    _createVNode(_component_confirm_delete_class_modal, {
      id: "confirmDeleteClassModal",
      "class-info": _ctx.currentClassInfo,
      onDeleteClass: _ctx.deleteClass
    }, null, 8, ["class-info", "onDeleteClass"])
  ]))
}